/**
 * The triggers the customer bundle always carries: the generic webhook and the
 * six providers a brand can connect. `registry.ts` seeds the live registry
 * from here.
 */

import { genericWebhookTrigger } from '@/triggers/generic'
import { gmailPollingTrigger } from '@/triggers/gmail'
import { googleDrivePollingTrigger } from '@/triggers/google-drive'
import { hubspotPollingTrigger } from '@/triggers/hubspot'
import {
  jiraCommentDeletedTrigger,
  jiraCommentUpdatedTrigger,
  jiraIssueCommentedTrigger,
  jiraIssueCreatedTrigger,
  jiraIssueDeletedTrigger,
  jiraIssueUpdatedTrigger,
  jiraProjectCreatedTrigger,
  jiraSprintClosedTrigger,
  jiraSprintCreatedTrigger,
  jiraSprintStartedTrigger,
  jiraVersionReleasedTrigger,
  jiraWebhookTrigger,
  jiraWorklogCreatedTrigger,
  jiraWorklogDeletedTrigger,
  jiraWorklogUpdatedTrigger,
} from '@/triggers/jira'
import {
  notionCommentCreatedTrigger,
  notionDatabaseCreatedTrigger,
  notionDatabaseDeletedTrigger,
  notionDatabaseSchemaUpdatedTrigger,
  notionPageContentUpdatedTrigger,
  notionPageCreatedTrigger,
  notionPageDeletedTrigger,
  notionPagePropertiesUpdatedTrigger,
  notionWebhookTrigger,
} from '@/triggers/notion'
import { slackOAuthTrigger, slackWebhookTrigger } from '@/triggers/slack'
import type { TriggerRegistry } from '@/triggers/types'

export const TRIGGERS_CORE: TriggerRegistry = {
  slack_oauth: slackOAuthTrigger,
  slack_webhook: slackWebhookTrigger,
  generic_webhook: genericWebhookTrigger,
  gmail_poller: gmailPollingTrigger,
  google_drive_poller: googleDrivePollingTrigger,
  jira_webhook: jiraWebhookTrigger,
  jira_issue_created: jiraIssueCreatedTrigger,
  jira_issue_updated: jiraIssueUpdatedTrigger,
  jira_issue_deleted: jiraIssueDeletedTrigger,
  jira_issue_commented: jiraIssueCommentedTrigger,
  jira_comment_updated: jiraCommentUpdatedTrigger,
  jira_comment_deleted: jiraCommentDeletedTrigger,
  jira_worklog_created: jiraWorklogCreatedTrigger,
  jira_worklog_updated: jiraWorklogUpdatedTrigger,
  jira_worklog_deleted: jiraWorklogDeletedTrigger,
  jira_sprint_created: jiraSprintCreatedTrigger,
  jira_sprint_started: jiraSprintStartedTrigger,
  jira_sprint_closed: jiraSprintClosedTrigger,
  jira_project_created: jiraProjectCreatedTrigger,
  jira_version_released: jiraVersionReleasedTrigger,
  notion_page_created: notionPageCreatedTrigger,
  notion_page_properties_updated: notionPagePropertiesUpdatedTrigger,
  notion_page_content_updated: notionPageContentUpdatedTrigger,
  notion_page_deleted: notionPageDeletedTrigger,
  notion_database_created: notionDatabaseCreatedTrigger,
  notion_database_schema_updated: notionDatabaseSchemaUpdatedTrigger,
  notion_database_deleted: notionDatabaseDeletedTrigger,
  notion_comment_created: notionCommentCreatedTrigger,
  notion_webhook: notionWebhookTrigger,
  hubspot_poller: hubspotPollingTrigger,
}
